module.exports = __webpack_public_path__ + "static/media/choose_us_3_selected.ac972005.png";